// extracted by mini-css-extract-plugin
export default {"nav":"NavBar_nav__aE7kl","navLogo":"NavBar_navLogo__vRzV7","navInputsContainer":"NavBar_navInputsContainer__D+ft2","navLangSelect":"NavBar_navLangSelect__kM0Ff"};